module.exports = "../../../../platform/assets/pageMainIcon/icon-riqi-1-yellow.svg";